module.exports = __webpack_public_path__ + "static/img/蒙版组 266@2x.044cafa7.png";